import PortfolioHoldingContainer from "./PortfolioHoldingContainer";
import PortfolioHoldingStore from "./PortfolioHoldingStore";
export default PortfolioHoldingStore(PortfolioHoldingContainer);